import { render, staticRenderFns } from "./ScoreboardBOResumeActions.vue?vue&type=template&id=2a22fd32"
import script from "./ScoreboardBOResumeActions.vue?vue&type=script&lang=js"
export * from "./ScoreboardBOResumeActions.vue?vue&type=script&lang=js"
import style0 from "./ScoreboardBOResumeActions.vue?vue&type=style&index=0&id=2a22fd32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports